import { ReactNode } from "react";
import { Navigate, useParams } from "react-router-dom";
import { store } from "../../store/store";

type RedirectProps = {
    children: ReactNode;
};

type PaymentProps = {
    children: ReactNode;
};

function PaymentInfo() {
    const data: any = store.getState().paymentApi?.queries;
    const keyQueries: any = Object.keys(data).find(res => res.includes('getPayment'));
    const getPayment = data[keyQueries]?.data;
    return getPayment;
}

export function GuardRedirectRoute({children}: RedirectProps) {
    const { id, key } = useParams<string>();
    const getPayment = PaymentInfo();
    return getPayment?.isRedirectOperation || getPayment?.isPostePayActive ? <>{children}</> : <Navigate to={`/${id}/${key}`} />
}

export function GuardPayment({children}: PaymentProps) {
    const { id, key } = useParams<string>();
    const getPayment = PaymentInfo();
    return !getPayment?.isRedirectOperation ? <>{children}</> : <Navigate to={`/${id}/${key}/redirect`}  />
}

export function OutcomeGuard({children}: PaymentProps) {
    const { id, key } = useParams<string>();
    const getPayment = PaymentInfo();
    return getPayment.payment.state !== 'INIT' ? <>{children}</> : <Navigate to={`/${id}/${key}`}  />
}